import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["disabled", "selected", "children", "className", "component", "onClick", "tabIndex", "value"];
import React from 'react';
import styled from 'styled-components';
import { COLORS, SIZES } from '../styleVars';
import { Typography } from '../typography/Typography';
var SelectButton = styled.div.withConfig({
  componentId: "sc-bke3vm-0"
})(["min-width:", ";height:", ";line-height:", ";padding:0.2rem ", ";background-color:", ";border:1px solid ", ";border-radius:", ";outline:none;text-decoration:none;cursor:pointer;user-select:none;-webkit-tap-highlight-color:transparent;text-align:center;box-sizing:border-box;"], SIZES['72'], SIZES['24'], SIZES['16'], SIZES['16'], function (props) {
  return props.disabled ? COLORS.lightestGrey : props.selected ? COLORS.fupaSecondary : COLORS.white;
}, function (props) {
  return props.selected ? COLORS.fupaSecondary : COLORS.lightGrey;
}, SIZES['2']);
var Container = styled.div.withConfig({
  componentId: "sc-bke3vm-1"
})(["display:flex;justify-content:center;text-transform:none;"]);
var StyledTypography = styled(Typography).withConfig({
  componentId: "sc-bke3vm-2"
})(["&&&{color:", ";}"], function (props) {
  return props.disabled ? COLORS.grey : props.selected ? COLORS.white : COLORS.darkerGrey;
});

var ToggleButton = function ToggleButton(_ref) {
  var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$selected = _ref.selected,
      selected = _ref$selected === void 0 ? false : _ref$selected,
      children = _ref.children,
      className = _ref.className,
      component = _ref.component,
      onClick = _ref.onClick,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex,
      value = _ref.value,
      props = _objectWithoutProperties(_ref, _excluded);

  var handleClick = function handleClick() {
    if (!disabled) {
      onClick(value);
    }
  };

  return /*#__PURE__*/React.createElement(SelectButton, _extends({
    tabIndex: tabIndex,
    as: component,
    className: className,
    selected: selected,
    disabled: disabled,
    onClick: handleClick,
    value: value
  }, props), /*#__PURE__*/React.createElement(StyledTypography, {
    disabled: disabled,
    selected: selected,
    variant: "caption3"
  }, children));
};

var ToggleButtons = function ToggleButtons(_ref2) {
  var children = _ref2.children,
      onChange = _ref2.onChange,
      activeValue = _ref2.activeValue;
  children = children.map(function (child) {
    /** @ts-ignore */
    var buttonValue = child.props.value;
    var selected = buttonValue === activeValue;
    /** @ts-ignore */

    return /*#__PURE__*/React.cloneElement(child, {
      key: buttonValue,
      selected: selected,
      onClick: function onClick(buttonValue) {
        return onChange(buttonValue);
      }
    });
  });
  return /*#__PURE__*/React.createElement(Container, null, children);
};

export { ToggleButtons, ToggleButton };
//# sourceMappingURL=ToggleButton.js.map